import { render } from "./RoleNameInput.vue?vue&type=template&id=34327d2c&scoped=true&ts=true&lang=pug"
import script from "./RoleNameInput.vue?vue&type=script&lang=ts"
export * from "./RoleNameInput.vue?vue&type=script&lang=ts"

import "./RoleNameInput.vue?vue&type=style&index=0&id=34327d2c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34327d2c"]])

export default __exports__